import React from 'react';
import { styled } from '@components-shared/src/stitches';
import { usePlayerTrackInfo } from '@components/AudioPlayer/usePlayerTrackInfo';
import { WebWorkerImage } from '@components/basics/Images/WebWorkerImage';
import { NextFutureImage } from '@components/main-components/image/NextFutureImage';
import blurImage from '@components/main-components/image/blur-image';
import { useAudioController } from '@store/audio/AudioController';

const IMAGE_SIZE = 400;

export const ReleaseCover = () => {
  const { activeTrackId } = useAudioController();

  const { releaseInfo } = usePlayerTrackInfo({
    trackId: activeTrackId,
    shouldFetch: true,
  });

  return (
    <ReleaseImage>
      {!!releaseInfo?.animatedCoverImage ? (
        <WebWorkerImage src={releaseInfo.animatedCoverImage.url} width="100%" height="100%" />
      ) : (
        !!releaseInfo?.coverImage && (
          <NextFutureImage
            alt={releaseInfo?.title || ''}
            src={releaseInfo.coverImage.url}
            width={IMAGE_SIZE}
            height={IMAGE_SIZE}
            placeholder="blur"
            blurDataURL={blurImage(IMAGE_SIZE * 2, IMAGE_SIZE * 2)}
            style={{
              objectFit: 'cover',
              objectPosition: 'center',
            }}
          />
        )
      )}
      <Gradient />
    </ReleaseImage>
  );
};

const ReleaseImage = styled('div', {
  display: 'block',
  position: 'relative',
  height: '58dvh',

  img: {
    width: '100%',
    height: '60dvh',
    objectFit: 'fill',
  },
});

const Gradient = styled('div', {
  position: 'absolute',
  top: 0,
  width: '100%',
  height: '62dvh',
  background:
    'linear-gradient(180deg, rgba(0, 0, 0, 0.6) 4%, rgba(0, 0, 0, 0.4) 10%, rgba(0, 0, 0, 0) 50%, #000 94%)',
});
